export const commListState = {
  fetching: false,
  msg: '',
  btnList: [],
  tableList: [],
  searchParam: {},
  searchData: {},
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: total => `共 ${total} 条数据`,
    showQuickJumper: true
  }
};

export const commDetailState = {
  code: '',
  view: false,
  fetching: false,
  selectData: {},
  pageData: {},
  isLoaded: false
};
